import { createContext, useContext } from 'react';
import { DEFAULT_CONFIG } from '../../model/config/default';
export var ConfigContext = createContext({
  config: DEFAULT_CONFIG,
  updateConfig: function updateConfig() {
    return undefined;
  }
});
export function useConfig() {
  var _useContext = useContext(ConfigContext),
      config = _useContext.config;

  return config;
}
export function useUpdateConfig() {
  var _useContext2 = useContext(ConfigContext),
      updateConfig = _useContext2.updateConfig;

  return updateConfig;
}